var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1202_71377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.405029,
    width: 18,
    height: 18,
    fill: "#818181"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1202_71377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99961 12.0863C9.84961 12.0863 10.5714 11.7893 11.1649 11.1953C11.7589 10.6018 12.0559 9.88003 12.0559 9.03003C12.0559 8.18003 11.7589 7.45828 11.1649 6.86478C10.5714 6.27078 9.84961 5.97378 8.99961 5.97378C8.14961 5.97378 7.42786 6.27078 6.83436 6.86478C6.24036 7.45828 5.94336 8.18003 5.94336 9.03003C5.94336 9.88003 6.24036 10.6018 6.83436 11.1953C7.42786 11.7893 8.14961 12.0863 8.99961 12.0863ZM8.99961 11.055C8.43711 11.055 7.95911 10.858 7.56561 10.464C7.17161 10.0705 6.97461 9.59253 6.97461 9.03003C6.97461 8.46753 7.17161 7.98928 7.56561 7.59528C7.95911 7.20178 8.43711 7.00503 8.99961 7.00503C9.56211 7.00503 10.0404 7.20178 10.4344 7.59528C10.8279 7.98928 11.0246 8.46753 11.0246 9.03003C11.0246 9.59253 10.8279 10.0705 10.4344 10.464C10.0404 10.858 9.56211 11.055 8.99961 11.055ZM8.99961 14.28C7.27461 14.28 5.70286 13.805 4.28436 12.855C2.86536 11.905 1.82461 10.63 1.16211 9.03003C1.82461 7.43003 2.86536 6.15503 4.28436 5.20503C5.70286 4.25503 7.27461 3.78003 8.99961 3.78003C10.7246 3.78003 12.2966 4.25503 13.7156 5.20503C15.1341 6.15503 16.1746 7.43003 16.8371 9.03003C16.1746 10.63 15.1341 11.905 13.7156 12.855C12.2966 13.805 10.7246 14.28 8.99961 14.28ZM8.99961 13.155C10.4121 13.155 11.7091 12.783 12.8906 12.039C14.0716 11.2955 14.9746 10.2925 15.5996 9.03003C14.9746 7.76753 14.0716 6.76428 12.8906 6.02028C11.7091 5.27678 10.4121 4.90503 8.99961 4.90503C7.58711 4.90503 6.29011 5.27678 5.10861 6.02028C3.92761 6.76428 3.02461 7.76753 2.39961 9.03003C3.02461 10.2925 3.92761 11.2955 5.10861 12.039C6.29011 12.783 7.58711 13.155 8.99961 13.155Z",
    fill: "#818181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.8285b9bdb62390b759c6b89c9bf94c62.svg";
export { ForwardRef as ReactComponent };